import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';


import { useHookStore } from "../../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../../utils/marks';

import "../DiffusionOptionsDesc/DiffusionOptionsDesc.css";

import StrInputImage from "../../../image/for-style-change/for-about/sch-input-manwoman-h125.jpg"
import StrMaskImage from "../../../image/for-style-change/for-about/sch-mask-manwoman-1-h100.jpeg"
import StrStyleImage from "../../../image/for-style-change/option-description/eta/sch-style-oil-painting-h100.jpeg";
import StrOutputImage1 from "../../../image/for-style-change/option-description/strength/manwoman-output-oil-str0.4-h125.jpeg";
import StrOutputImage2 from "../../../image/for-style-change/option-description/strength/manwoman-output-oil-str0.7-h125.jpeg";


function StyleChangeDescStrength() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      // inputEta
    } = hStore.iopaintStore;

    return (
      <div className="diffsionOptionDesc">
        <div className="diffsionOptionDescRow">
          {t('syleChangeOptions16', 'When higher value is used, more styles are transferd, but shape of image contents become different from input image based on other inputs.')}
          <br/>
          {t('syleChangeOptions17', 'When lower value is used, shape of image contents is similar to input image, but less styles are transfered.')}
          <br/>
          0.4{' '}
          {t('syleChangeOptions18', 'is good starting point for image generation.')}
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">
            <div>
              <img className="diffsionOptionDescImage"
                src={StrInputImage}
              />
              {t('aboutPage.13', 'Input image')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={StrMaskImage}
              />
              {t('aboutStyleChange05', 'Selected part')}
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={StrStyleImage}
              />
              {t('aboutStyleChange06', 'Style image')}
            </div>
          </div>
        </div>
        <div className="diffsionOptionDescRow">
          <div className="diffsionOptionDescImages">

            <div>
              <img className="diffsionOptionDescImage"
                src={StrOutputImage1}
              />
              0.4
            </div>
            <div>
              <img className="diffsionOptionDescImage"
                src={StrOutputImage2}
              />
              0.7
            </div>
          </div>
        </div>
      </div>
    )
  }


export default StyleChangeDescStrength